import { render, staticRenderFns } from "./PalletRackGableTop.vue?vue&type=template&id=fff6f0ee"
import script from "./PalletRackGableTop.vue?vue&type=script&lang=js"
export * from "./PalletRackGableTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports